import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { checkSession, logout } from "../utils/api"; // ✅ use backend session check
import AdminNavbar from "./AdminNavbar";
import AdminDashboard from "./AdminDashboard";
import Login from "./Login";

function AdminLandingPage() {
  const [role, setRole] = useState(null); // 'admin' or 'user'
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // ✅ Check backend session
    checkSession()
      .then((res) => {
        if (!res.loggedIn) {
          setIsLoggedIn(false);
          setRole(null);
        } else {
          setRole(res.role);
          setIsLoggedIn(true);
        }
      })
      .catch((err) => {
        console.error("Session check failed:", err);
        setIsLoggedIn(false);
        setRole(null);
      });
  }, []);

  const handleLogout = async () => {
    await logout(); // ✅ clear backend session
    sessionStorage.clear(); // optional local cleanup
    setIsLoggedIn(false);
    setRole(null);
    navigate("/login");
  };

  if (!isLoggedIn) {
    return (
      <Login
        onLoginSuccess={(r) => {
          setRole(r);
          setIsLoggedIn(true);
        }}
      />
    );
  }

  return (
    <div className="admin-landing">
      <AdminNavbar onLogout={handleLogout} />
      <div className="container mt-5 pt-4">
        {role === "admin" ? (
          <div className="admin-sections">
            <AdminDashboard />
          </div>
        ) : (
          <div className="user-sections">
            <AdminDashboard />
            {/* maybe limited view for users */}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminLandingPage;
